/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/bolmateButton.scss';
import './style/bolmateToggleButton.scss';

import React, {MouseEvent, MouseEventHandler, ReactNode, useState} from 'react';

import {OrnamentShape} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import {BolmateControlColor, BolmateControlShape, BolmateControlSize} from '../../../util/types';

import BolmateButton from './bolmateButton';

interface Props {
    label: ReactNode;
    active?: boolean;
    defaultActive?: boolean;
    onToggle?: (active: boolean) => void;
    onClick?: MouseEventHandler;
    ornaments?: OrnamentShape | OrnamentShape[];
    disabled?: boolean;
    className?: string;
    labelClassName?: string;
    ornamentClassName?: string;
    secondary?: boolean;
    color?: BolmateControlColor;
    size?: BolmateControlSize;
    shape?: BolmateControlShape;
    id?: string;
}

export default function BolmateToggleButton({
    active,
    defaultActive = false,
    onToggle,
    className,
    disabled,
    onClick,
    ...rest
}: Props) {
    const [internalActive, setInternalActive] = useState(defaultActive);
    const isControlled = active !== undefined;
    const isActive = isControlled ? active : internalActive;

    const handleClick = (e: MouseEvent) => {
        if (disabled) return;

        const newValue = !isActive;
        if (!isControlled) {
            setInternalActive(newValue);
        }
        onToggle?.(newValue);
        onClick?.(e);
    };

    return (
        <BolmateButton
            {...rest}
            disabled={disabled}
            className={classNames(className, 'toggle-button', !isActive && 'inactive')}
            onClick={handleClick}
        />
    );
}
